import "./summaryListItem.scss";

import PropTypes from 'prop-types';

function SummaryListItem(props) {
    const { text, value } = props;
    return (
        <div className="summary-list-item">
            <p className="summary-list-item__label">{text}</p>
            <p className="summary-list-item__value">{value}</p>
        </div>
    );
}

SummaryListItem.propTypes = {
    text: PropTypes.string,
    value: PropTypes.string
};

export default SummaryListItem;
